if (!customElements.get('sale-promo-strip')) {
  class SalePromoStrip extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.dismissKey = 'sps-dismissed-' + this.sectionId;
    }

    connectedCallback() {
      if (this.dataset.dismissible && sessionStorage.getItem(this.dismissKey) === '1') {
        this.hidden = true;
        return;
      }

      this._bindCopy();
      this._bindClose();
      this._publishHeight();

      this._ro = new ResizeObserver(() => this._publishHeight());
      this._ro.observe(this);

      window.addEventListener('resize', this._publishHeight.bind(this));
    }

    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
    }

    _publishHeight() {
      if (this.hidden) {
        document.documentElement.style.setProperty('--promo-strip-height', '0px');
        return;
      }
      const h = this.offsetHeight || 0;
      document.documentElement.style.setProperty('--promo-strip-height', h + 'px');
    }

    _bindCopy() {
      const btn = this.querySelector('[data-sps-copy]');
      if (!btn) return;
      btn.addEventListener('click', () => this._copy(btn));
    }

    _copy(btn) {
      const code = btn.dataset.spsCopy;
      if (!code) return;
      const flash = () => {
        btn.classList.add('sps--copied');
        clearTimeout(this._copyTimer);
        this._copyTimer = setTimeout(() => btn.classList.remove('sps--copied'), 1500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(flash).catch(flash);
      } else {
        const ta = document.createElement('textarea');
        ta.value = code;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        flash();
      }
    }

    _bindClose() {
      const close = this.querySelector('[data-sps-close]');
      if (!close) return;
      close.addEventListener('click', () => {
        try { sessionStorage.setItem(this.dismissKey, '1'); } catch (e) {}
        this.hidden = true;
        this._publishHeight();
      });
    }
  }

  customElements.define('sale-promo-strip', SalePromoStrip);
}
